import { postVrmCheck } from 'PublicAPI';

import {
  CHECK_PERFORMED_SERVICE_TYPE,
  CHECK_TOOLS_CATEGORIES_LIST,
  CHECKER_TOOLS_EVENTS,
  CHECKER_TOOLS_PAGE_SECTIONS_LIST,
  MOT_CHECK_NOTIFICATIONS_NAME,
  TAX_CHECK_NOTIFICATIONS_NAME,
} from 'Utilities/analytics';
import { defaultLazyLoadOptions } from 'Utilities/constants';
import { toTitleCase } from 'Utilities/formatter';
import {
  coerceVRM, composeValidators, emailValidator, getFieldState,
  getFieldStateWithSubmissionErrors,
  isValidVRM, phoneNumberValidator,
  platformEmailValidator,
  requiredValidator, stripSpaces, unprettyVRM,
  VRMValidator,
} from 'Utilities/formValidators';
import { useQuery } from 'Utilities/hooks';
import { safeLocalStorage } from 'Utilities/storages';
import { User } from 'Utilities/user/@types';
import { MOT_PAGE_ROUTES, TAX_PAGE_ROUTES, VALUATION_TRACKER_ROUTES } from 'Utilities/wordpress';

import { BreakpointProvider, useBreakpoint } from '../../../../components/misc/Breakpoints/Breakpoints';
import { usePageRefEvents } from '../../common/Hooks/usePageRefEvents';
import { createFAQData } from '../../contentPages/landingPages/FAQSection/FAQSection';
import { useCreateEnquiryAction } from '../../valuations/Hooks/useCreateEnquiryAction';

export {
  CHECKER_TOOLS_EVENTS,
  CHECKER_TOOLS_PAGE_SECTIONS_LIST as CHECKER_TOOLS_PAGE_SECTIONS,
  CHECK_TOOLS_CATEGORIES_LIST,
  MOT_CHECK_NOTIFICATIONS_NAME,
  TAX_CHECK_NOTIFICATIONS_NAME,
  CHECK_PERFORMED_SERVICE_TYPE,
};
export { defaultLazyLoadOptions };
export { toTitleCase };
export type { User };

export {
  coerceVRM, composeValidators, getFieldState,
  isValidVRM, requiredValidator, stripSpaces, VRMValidator, unprettyVRM,
  postVrmCheck, getFieldStateWithSubmissionErrors, platformEmailValidator, emailValidator, phoneNumberValidator,
};
export { useQuery };
export { safeLocalStorage };

export { usePageRefEvents };
export { createFAQData };
export { useBreakpoint, BreakpointProvider };
export { useCreateEnquiryAction };

export const MOT_VALUATION_ROUTE = MOT_PAGE_ROUTES[0];
export const TAX_VALUATION_ROUTE = TAX_PAGE_ROUTES[0];
export const MOT_RESULT_ROUTE = MOT_PAGE_ROUTES[1];
export const TAX_RESULT_ROUTE = TAX_PAGE_ROUTES[1];
export const MOT_CHECK_KEY = 'motCheckData';
export const CVT_MILEAGE_ROUTE = `${VALUATION_TRACKER_ROUTES}/mileage`;
export const MILEAGE_ROUTE = '/mileage';
export const SIGNIN_ROUTE = '/sign-in';
export const getReferBannerLink = (identifier: string) => `/refer?utm_source=mentionme&utm_medium=affiliate&utm_campaign=referafriend_${identifier}&situation=${identifier}`;
